var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import './tabActive';
import { TabController } from './tabController';
import { updateNrOfTabs } from './tabEvent';
let Tabs = class Tabs extends BaseComponent {
    constructor() {
        super(...arguments);
        this.width = 0;
        this.tabController = undefined;
    }
    firstUpdated() {
        var _a;
        const slot = this.shadowRoot.querySelector('slot');
        const children = slot === null || slot === void 0 ? void 0 : slot.assignedElements({ flatten: true });
        this.dispatchEvent(updateNrOfTabs(this.key, (_a = children === null || children === void 0 ? void 0 : children.length) !== null && _a !== void 0 ? _a : 0));
        this.tabController = new TabController(this, this.key);
        this.requestUpdate();
    }
    willUpdate(_changedProperties) {
        const slot = this.shadowRoot.querySelector('slot');
        const children = slot === null || slot === void 0 ? void 0 : slot.assignedElements({ flatten: true });
        if (children) {
            const activeTab = children[this.tabController.activeTab];
            const tab = activeTab.getBoundingClientRect();
            const width = tab.width;
            this.width = width;
        }
    }
    render() {
        if (!this.tabController) {
            return nothing;
        }
        return html `
        <div class="border-b-[1px] border-bluegray">
            <slot class="flex"></slot>
            <trust-tab-active key=${this.key} activeTab=${this.tabController.activeTab} width=${this.width}></trust-tab-active>
        </div>
        `;
    }
};
__decorate([
    property()
], Tabs.prototype, "key", void 0);
__decorate([
    state()
], Tabs.prototype, "width", void 0);
Tabs = __decorate([
    customElement('trust-tabs')
], Tabs);
export { Tabs };
//# sourceMappingURL=tabs.js.map